import { ROLES } from '@asurion-core/typescript-utils/SimplrUserAuthorization';

export { ROLES };

export const EXPERT = ROLES.EXPERT;
export const SPECIALIST = ROLES.SPECIALIST;
export const SUPER_ADMIN = ROLES.SUPER_ADMIN;
export const PARTNER_PROTECTOR = ROLES.PARTNER_PROTECTOR;
export const ACCOUNT_USER = ROLES.ACCOUNT_USER;

export const nonSuperAdminRoles = [ROLES.EXPERT, ROLES.SPECIALIST, ROLES.PARTNER_PROTECTOR, ROLES.ACCOUNT_USER];
